import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { ValueRangeType } from '../../enums/global.enum';

export class ValueRange {
  private GLOBAL_CONSTANT = GLOBAL_CONSTANT;
  constructor(
    public min: number,
    public max: number,
    public type: ValueRangeType,
    public measurementTypeID: number
  ) {}

  public getZoneColor() {
    switch (this.type) {
      case ValueRangeType.green:
        return this.GLOBAL_CONSTANT.ZONE_COLOR_GREEN;
      case ValueRangeType.yellow:
        return this.GLOBAL_CONSTANT.ZONE_COLOR_YELLOW;
      case ValueRangeType.red:
        return this.GLOBAL_CONSTANT.ZONE_COLOR_RED;
      default:
        return 'transparent';
    }
  }

  public getIconColor() {
    switch (this.type) {
      case ValueRangeType.green:
        return this.GLOBAL_CONSTANT.ICON_COLOR_GREEN;
      case ValueRangeType.yellow:
        return this.GLOBAL_CONSTANT.ICON_COLOR_YELLOW;
      case ValueRangeType.red:
        return this.GLOBAL_CONSTANT.ICON_COLOR_RED;
      default:
        return 'black';
    }
  }

  public getIcon() {
    switch (this.type) {
      case ValueRangeType.green:
        return '\uf058';
      case ValueRangeType.yellow:
        return '\uf12a';
      case ValueRangeType.red:
        return '\uf071';
    }
  }
}
